import { ChangeDetectionStrategy, Component, Inject, signal } from '@angular/core';
import { DOCUMENT_FILE_TYPES, DOCUMENT_UPLOAD_ACCEPT, isFileDrag, MAX_DOCUMENT_SIZE_LABEL } from '../../constants/document-upload';

// Picks files for the Auftragsbegleitschein's Dokumente tab: a drop zone plus a button for the
// device's file chooser. Closes with the chosen files right away (an empty list when cancelled);
// validation, image→PDF conversion and the upload happen in DocumentsComponent. Constructor DI:
// ModalService provides its callbacks under string tokens, which inject() can't take.
@Component({
  selector: 'app-document-upload-modal',
  standalone: true,
  templateUrl: './document-upload-modal.component.html',
  styleUrls: ['./document-upload-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '(document:keydown.escape)': 'close()',
  },
})
export class DocumentUploadModalComponent {
  public readonly accept = DOCUMENT_UPLOAD_ACCEPT;
  public readonly fileTypes = DOCUMENT_FILE_TYPES.map(type => type.label);
  public readonly maxSizeLabel = MAX_DOCUMENT_SIZE_LABEL;
  public readonly isDragOver = signal(false);

  constructor(@Inject('MODAL_CLOSE') private readonly modalClose: (result: File[]) => void) {}

  public onDragOver(event: DragEvent): void {
    if (!isFileDrag(event)) return;
    event.preventDefault();
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'copy';
    this.isDragOver.set(true);
  }

  public onDragLeave(event: DragEvent): void {
    // dragleave also fires when moving onto a child of the drop zone
    const zone = event.currentTarget as HTMLElement;
    if (zone.contains(event.relatedTarget as Node | null)) return;
    this.isDragOver.set(false);
  }

  public onDrop(event: DragEvent): void {
    if (!isFileDrag(event)) return;
    event.preventDefault();
    this.isDragOver.set(false);
    this.submit(event.dataTransfer?.files);
  }

  public onFileInputChange(fileInput: HTMLInputElement): void {
    this.submit(fileInput.files);
  }

  public close(): void {
    this.modalClose([]);
  }

  private submit(fileList: FileList | null | undefined): void {
    const files = Array.from(fileList ?? []);
    if (files.length > 0) this.modalClose(files);
  }
}
